import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-why-we-choose',
    templateUrl: './why-we-choose.component.html',
    styleUrls: ['./why-we-choose.component.scss'],
    imports: [RouterLink]
})
export class WhyWeChooseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
